import { useEffect, useRef, useState } from "react";
import "./globalCapDetailOverview.css";

function useRevealOnScroll() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return [ref, visible];
}

export default function GlobalCapDetailOverview({ data }) {
  const [ref, visible] = useRevealOnScroll();

  return (
    <section
      ref={ref}
      className={`gcdo ${visible ? "gcdo--visible" : ""}`}
    >
      <div className="gcdo__glow" aria-hidden="true" />

      <div className="gcdo__container">
        <div className="gcdo__heading-col">
          <span className="gcdo__bar" aria-hidden="true" />
          <h2 className="gcdo__heading">{data.heading}</h2>
          <span className="gcdo__dots" aria-hidden="true" />
        </div>

        <div className="gcdo__body">
          <span className="gcdo__rail" aria-hidden="true">
            <span className="gcdo__rail-fill" />
          </span>

          {data.body.map((paragraph, index) => (
            <div
              className={`gcdo__item ${index === 0 ? "gcdo__item--lead" : ""}`}
              style={{ "--i": index }}
              key={index}
            >
              <span className="gcdo__node" aria-hidden="true" />
              <p className="gcdo__text">{paragraph}</p>
            </div>
          ))}

          <span className="gcdo__end" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}
